import { QUERY_GET_BRANDS,QUEY_GET_MASTER_COUNT, QUERY_GET_MASTER_BRANDS, QUERY_GET_BRANDSPAG, QUERY_POST_CREATE_BRAND, QUERY_PUT_UPDATE_BRAND, QUERY_DELETE_DELETE_BRAND} from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getMasterBrands = baseThunk("brandList/getBrands", QUERY_GET_MASTER_BRANDS, "GET");

export const getBrands = baseThunk(`brands/getBrands`, QUERY_GET_BRANDS, "GET");
export const getBrandsPag = baseThunk(`brands/getBrandsPag`, QUERY_GET_BRANDSPAG, "GET");
export const getBrandsPagCount = baseThunk("brands/getBrandListCount", QUEY_GET_MASTER_COUNT, "GET");
export const createBrand = baseThunk("brands/create", QUERY_POST_CREATE_BRAND, "POST");
export const updateBrand = baseThunk('brands/update', QUERY_PUT_UPDATE_BRAND, "PUT")
export const deleteBrand = baseThunk(`brands/delete`, QUERY_DELETE_DELETE_BRAND, "DELETE")
